<template>
    <div>
        <label for="buscaCid">
            {{ label }}
        </label>
        <autosuggest
            ref="autoBuscaCid"
            id="buscaCid"
            :url="$urlBase + '/cidades/buscaCidades'"
            :default="carregaCidade()"
            @result="selecionaCidade"
        />
    </div>
</template>
<script>
import Autosuggest from '@/shared/components/ui/Autosuggest'
export default {
    props: {  
        label: {
            default: 'Município/UF carregamento'
        },
        filtro: {
            default: null
        },
        municipio_carregamento: {
            default: null
        }
    },
    components: {
        Autosuggest
    },
    watch: {
        'filtro.municipio_carregamento'(valor) {
            if(!valor){
                this.$refs.autoBuscaCid.onClear()
            }
        }
    },
    methods: {
        carregaCidade() {
            if (this.filtro['municipio_carregamento'] != '') {
                return {
                    codigo: this.filtro.municipio_carregamento,
                    nome: this.filtro.municipio_carregamento_nome
                }
            } else {
                return null
            }
        },
        selecionaCidade(value) {
            if (value) {
                this.filtro.municipio_carregamento = value.codigo
                this.filtro.municipio_carregamento_nome = value.nome
            } else {
                this.filtro.municipio_carregamento = ''
                this.filtro.municipio_carregamento_nome = ''
            }
        },
    }
}
</script>